// ======================================================================
// File Name       : GroupConstants
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import * as ModalIds from './ModalIds';

export const REDIRECT_MODAL = {
  [ModalIds.GROUP_DETAIL]: {
    OK: ModalIds.GROUP_REGISTER_EDIT,
  },
  [ModalIds.GROUP_REGISTER_EDIT]: {
    OK: ModalIds.GROUP_USER_ADMIN,
  },
  [ModalIds.GROUP_USER_ADMIN]: {
    OK: ModalIds.GROUP_USER_NOT_ADMIN,
    CANCEL: ModalIds.GROUP_REGISTER_EDIT,
  },
  [ModalIds.GROUP_USER_NOT_ADMIN]: {
    OK: ModalIds.GROUP_CONFIRM,
    CANCEL: ModalIds.GROUP_USER_ADMIN,
  },
  [ModalIds.GROUP_CONFIRM]: {
    CANCEL: ModalIds.GROUP_USER_NOT_ADMIN,
    ERROR: ModalIds.GROUP_REGISTER_EDIT,
  },
};

export const DATA_LIMIT_FLAG = {
  DO_NOT_LIMIT: 0,
  LIMIT: 1,
};
